import { Outlet } from "react-router-dom";
import { AppBar, Box, Toolbar, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { PlantSelector } from "@/screens/Home/components/PlanSelector";

const Body = styled("div")<{ bigHeader?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 30px;
  margin: auto;
  max-width: 1200px;
  margin-top: 56px;
  min-height: calc(100vh - 56px);
  ${(props) => props.theme.breakpoints.up(600)} {
    margin-top: 64px;
    min-height: calc(100vh - 64px);
  }

  ${(props) => props.theme.breakpoints.up(0)} @media (orientation: landscape) {
    margin-top: 48px;
    min-height: calc(100vh - 48px);
  }
`;

export const HistoryLayout = () => {
  return (
    <Body>
      <AppBar position="fixed">
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <PlantSelector />
          </Box>

          <Link to={"/"}>
            <img src={"/logo.png"} alt="logo" />
          </Link>
        </Toolbar>
      </AppBar>
      <Outlet />
    </Body>
  );
};
